module.exports = __webpack_public_path__ + "static/rayures_zebre-1f0f78760205f7905f8b1c21f4a919bb.png";